import { __assign, __rest } from "tslib";
// DS: I119
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
export var Error = function (_a) {
    var _b = _a.withBackground, withBackground = _b === void 0 ? false : _b, props = __rest(_a, ["withBackground"]);
    return (React.createElement(IconWrap, __assign({}, props),
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", viewBox: "0 0 24 24" },
            React.createElement("path", { fillRule: "evenodd", d: "M12 4a8 8 0 110 16 8 8 0 010-16zm0 10a1 1 0 100 2 1 1 0 000-2zm1-6h-2v4.97h2V8z" }),
            withBackground && (React.createElement("path", { fill: "#fff", d: "M12 14a1 1 0 100 2 1 1 0 000-2zm1-6h-2v4.97h2V8z" })))));
};
export default Error;
//# sourceMappingURL=Error.js.map